// extracted by mini-css-extract-plugin
module.exports = {"loadingOverlay":"loading-overlay-module--loadingOverlay--ct2mn","header":"loading-overlay-module--header--1ao3-","fadeOut":"loading-overlay-module--fadeOut--14JRs"};